/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Hyphen_Space_LabelInputs */



/**
* | output |
* | --- |
* | "Hyphen With Space" |
*
* @param {Style_Guide_Manager_Hyphen_Space_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_hyphen_space_label = /** @type {((inputs?: Style_Guide_Manager_Hyphen_Space_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Hyphen_Space_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tiret avec espace")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bindestrich mit Leerzeichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trattino con spazio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Дефис с пробелом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guión con espacio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带空格的连字符")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペース付きハイフン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाइफ़न के साथ स्पेस")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Hífen com espaço")
	return /** @type {LocalizedString} */ ("Hyphen With Space")
});